import request from "@/utils/request";

export default function agentSearchLast7DayChargeNumByGroupId(params) {
  return request({
    url: `/fund/agent/order/searchLast7DayChargeNumByGroupId?groupId=${params.id}`,
  });
}
